import request from '@/utils/request'


// 查询病情标签列表
export function listIllnessTag(query) {
  return request({
    url: '/biz/illness-tag/list',
    method: 'get',
    params: query
  })
}

// 查询病情标签分页
export function pageIllnessTag(query) {
  return request({
    url: '/biz/illness-tag/page',
    method: 'get',
    params: query
  })
}

// 查询病情标签详细
export function getIllnessTag(data) {
  return request({
    url: '/biz/illness-tag/detail',
    method: 'get',
    params: data
  })
}

// 新增病情标签
export function addIllnessTag(data) {
  return request({
    url: '/biz/illness-tag/add',
    method: 'post',
    data: data
  })
}

// 修改病情标签
export function updateIllnessTag(data) {
  return request({
    url: '/biz/illness-tag/edit',
    method: 'post',
    data: data
  })
}

// 删除病情标签
export function delIllnessTag(data) {
  return request({
    url: '/biz/illness-tag/delete',
    method: 'post',
    data: data
  })
}

export function queryMenuList(query) {
  return request({
    url: '/biz/illness-tag/queryMenuList',
    method: 'get',
    params: query
  })
}

export function queryTagListByLevel(query) {
  return request({
    url: '/biz/illness-tag/queryTagListByLevel',
    method: 'get',
    params: query
  })
}
